import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  return <Section background="white" data-id="element-435">
      <div className="text-center mb-16" data-id="element-436">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4" data-id="element-437">
          Ellas ya dominaron el arte
        </h2>
        <div className="flex justify-center gap-1" data-id="element-438">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-amber-500 text-amber-500" data-id="element-439" />)}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-440">
        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 relative" data-id="element-441">
          <div className="absolute -top-4 -left-4 text-6xl text-amber-200 font-serif leading-none" data-id="element-442">
            "
          </div>
          <p className="text-stone-700 text-lg italic mb-6 relative z-10" data-id="element-443">
            Vivo en Miami y la humedad siempre arruinaba mis postres. Hice el
            Mil Hojas para el cumpleaños de mi suegra y{' '}
            <span className="font-bold text-stone-900" data-id="element-444">
              se mantuvo crujiente por 2 días
            </span>
            . ¡No lo podía creer!
          </p>
          <div className="flex items-center gap-4" data-id="element-445">
            <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center text-amber-800 font-bold text-lg" data-id="element-446">
              C
            </div>
            <div data-id="element-447">
              <p className="font-bold text-stone-900" data-id="element-448">Carolina M.</p>
              <p className="text-sm text-stone-500" data-id="element-449">Miami, FL</p>
            </div>
          </div>
        </div>

        <div className="bg-stone-50 p-8 rounded-xl border border-stone-100 relative" data-id="element-450">
          <div className="absolute -top-4 -left-4 text-6xl text-amber-200 font-serif leading-none" data-id="element-451">
            "
          </div>
          <p className="text-stone-700 text-lg italic mb-6 relative z-10" data-id="element-452">
            Siempre me daba vergüenza llevar postres porque llegaban feos. Con
            esta técnica, el corte salió perfecto.{' '}
            <span className="font-bold text-stone-900" data-id="element-453">
              Mis amigas pensaron que lo compré en una pastelería francesa.
            </span>
          </p>
          <div className="flex items-center gap-4" data-id="element-454">
            <div className="w-12 h-12 bg-amber-200 rounded-full flex items-center justify-center text-amber-800 font-bold text-lg" data-id="element-455">
              S
            </div>
            <div data-id="element-456">
              <p className="font-bold text-stone-900" data-id="element-457">Sofia R.</p>
              <p className="text-sm text-stone-500" data-id="element-458">Houston, TX</p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}